<template>
    <v-layout>
        <v-flex xs12>
            <chapter-quick-links></chapter-quick-links>
            <about-tile v-if="canViewAboutTile" :can-view-about="canViewAbout" :can-view-chair="canViewChair" :can-view-sponsors="canViewSponsors"></about-tile>
            <!--<prospects-poll v-if="isVisible"></prospects-poll> Comment out this for preview since we don't want it yet - Lance -->
            <waivers-tile v-if="((isCommunityAdmin && currentCommunityView === userRoles.ADMIN) || canViewWaiversLink) && isChapterPage && isVisible" :community-type="routerNames.CHAPTER"></waivers-tile>
            <chapter-awards v-if="isVisible"></chapter-awards>
            <filesand-media v-if="canViewFilesAndMedia"></filesand-media>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters } from "vuex";
    import prospectsPoll from "../../components/ChapterPage/Prospects/Prospects";
    import ChapterAwards from "../../components/ChapterPage/ChapterAwards/ChapterAwards";
    import FilesandMedia from "../ChapterPage/FilesandMedia/FilesandMedia";
    import AboutTile from './AboutTile/AboutTile.vue';
    import ChapterQuickLinks from './ChapterQuickLinks.vue';
    import { storeGetters } from "../../store/storeGetters.constant";
    import { routerNames, userRoles } from "../appCommon.constants";
    import communityLeftSideBarMixin from "../../mixins/communityLeftSideBarMixin";
    import WaiversTile from "../ChapterWaiver/ChapterWaiverTile.vue";

    export default {
        name: 'ChapterLeftSidebar',
        mixins: [communityLeftSideBarMixin],
        components: {
            prospectsPoll,
            ChapterAwards,
            FilesandMedia,
            AboutTile,
            WaiversTile,
            ChapterQuickLinks,
        },
        data: () => {
            return {
                routerNames,
                userRoles,
            };
        },
        computed: {
            ...mapGetters({
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            }),
            isVisible() {
                return this.$route.params.communityId !== undefined;
            },
            isChapterPage() {
                return this.$route.name === this.routerNames.CHAPTER;
            },
            canViewFilesAndMedia() {
                return this.communityInfo
                    && this.communityInfo.communityId === this.$route.params.communityId
                    && this.communityInfo.userAccess &&
                    this.communityInfo.userAccess.canViewAllFilesAndMedia;
            },
        },
    };
</script>
